import { FC } from 'react';

import { Box } from '@material-ui/core';

import { NavBar } from 'common/components';
import { TNavBarProps } from 'common/components/templates/NavBar/types';
import { useAppSelector } from 'common/helpers/hooks';
import { getWhiteLabel } from 'common/store/global';

import LayoutStyles from './app-layout.styles';

type AppLayoutProps = {
  CustomNavBar?: FC<TNavBarProps>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  CustomFooter?: FC<any>;
};
const AppLayout: FC<AppLayoutProps> = ({ children, CustomNavBar = NavBar, CustomFooter }) => {
  const Styles = LayoutStyles();
  const whiteLabelLayout = useAppSelector(getWhiteLabel);

  if (whiteLabelLayout) {
    return (
      <div className={`${Styles.root} full-h`} id="app-layout">
        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          maxWidth={700}
          width="100%"
          justifyContent="center"
          mx="auto"
          overflow="hidden"
        >
          {children}
        </Box>
      </div>
    );
  }

  return (
    <>
      <CustomNavBar />

      <div className={Styles.root} id="app-layout">
        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          maxWidth={700}
          width="100%"
          justifyContent="center"
          mx="auto"
          overflow="hidden"
        >
          {children}
        </Box>
        {CustomFooter && <CustomFooter />}
      </div>
    </>
  );
};

export default AppLayout;
